import React from 'react';
import { ShoppingBag, Layers } from 'lucide-react';

export const MallHeader = ({ mall, rate, branch, branches, currency, setCurrency, user, compareCount, onCart, onCompare, onBranch }) => (
  <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0A192F]/85 border-b border-white/10" data-testid="mall-header">
    <div className="max-w-7xl mx-auto px-4 h-16 flex items-center gap-3">
      <a href={branch ? `../` : '#top'} className="flex items-center gap-2 shrink-0" data-testid="nav-brand-logo" onClick={(e) => { if (branch) { e.preventDefault(); onBranch(''); } }}>
        {mall?.logo_url ? (
          <img src={mall.logo_url} alt={mall?.brand_name || 'Tienda'} className="h-10 w-10 rounded-xl bg-white object-contain" />
        ) : (
          <div className="h-10 w-10 rounded-xl bg-[#FFC857] grid place-items-center text-[#0A192F] font-black">{(mall?.brand_name || 'S')[0]}</div>
        )}
        <div className="leading-none hidden sm:block">
          <p className="cb-display text-xl text-white">{mall?.brand_name || 'Tienda'}</p>
          {branch && <p className="text-[10px] tracking-[0.3em] text-white/60">{branch.name.toUpperCase()}</p>}
        </div>
      </a>
      <select value={branch?.slug || ''} onChange={(e) => onBranch(e.target.value)} data-testid="branch-selector-dropdown"
        className="ml-auto bg-white/10 text-white text-sm rounded-full px-3 py-2 border border-white/15 max-w-[150px] sm:max-w-none">
        <option value="" className="text-black">Todas las tiendas</option>
        {branches.map((b) => <option key={b.slug} value={b.slug} className="text-black">{b.name}</option>)}
      </select>
      {rate > 0 && <div className="hidden sm:flex rounded-full bg-white/10 p-1 text-xs font-bold">
        {['USD', 'BS'].map((c) => (
          <button key={c} data-testid={`currency-toggle-${c.toLowerCase()}`} onClick={() => setCurrency(c)}
            className={`px-3 py-1.5 rounded-full transition-colors ${currency === c ? 'bg-[#FFC857] text-[#0A192F]' : 'text-white/70'}`}>{c === 'BS' ? 'Bs.' : '$'}</button>
        ))}
      </div>}
      <button onClick={onCompare} className="relative text-white/80 hover:text-white p-2" data-testid="header-compare-btn" title="Comparar">
        <Layers size={20} />{compareCount > 0 && <span className="absolute -top-0.5 -right-0.5 bg-[#00F2FE] text-[#0A192F] text-[10px] font-black rounded-full w-4 h-4 grid place-items-center">{compareCount}</span>}
      </button>
      <button onClick={onCart} className="relative bg-[#FFC857] text-[#0A192F] rounded-full px-3 py-2 active:scale-95 transition-transform" data-testid="header-account-btn">
        <span className="flex items-center gap-1 text-xs font-black px-1"><ShoppingBag size={16} /> {user ? 'Mi cuenta' : 'Ingresar'}</span>
      </button>
    </div>
    {rate > 0 && <div className="sm:hidden flex justify-center pb-2">
      <div className="flex rounded-full bg-white/10 p-1 text-xs font-bold">
        {['USD', 'BS'].map((c) => <button key={c} data-testid={`currency-toggle-${c.toLowerCase()}-m`} onClick={() => setCurrency(c)} className={`px-4 py-1 rounded-full ${currency === c ? 'bg-[#FFC857] text-[#0A192F]' : 'text-white/70'}`}>{c === 'BS' ? 'Bs.' : 'USD $'}</button>)}
      </div>
    </div>}
  </header>
);

export default MallHeader;
